module.exports = __webpack_public_path__ + "img/tabler_send.f6124c00.svg";